//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Application from "eai-configurator-ui/components/Application";
import ConfigurationDashboard from "eai-configurator-ui/components/configuration/ConfigurationDashboard";
import AccountButton from "eai-configurator-ui/components/header/buttons/AccountButton";
import HelpButton from "eai-configurator-ui/components/header/buttons/HelpButton";
import MessagesButton from "eai-configurator-ui/components/header/buttons/MessagesButton";
import {useHistory} from "react-router-dom";
import Login from "eai-configurator-ui/components//login/Login";
import ManageUsersButton from "eai-configurator-ui/components/header/buttons/ManageUsersButton";
import ManageLoaderUsersDialog from "src/components/loader/dialog/ManageLoaderUsersDialog";
import ManageOfflineLicenseDialog from "eai-configurator-ui/components/configuration/dialog/ManageOfflineLicenseDialog";
import SaveConfigurationButton from "eai-configurator-ui/components/configuration/buttons/SaveConfigurationButton";
import LoaderTasksPage from "src/components/loader/pages/LoaderTasksPage";
import GetAppIcon from "@material-ui/icons/GetApp";
import TableChartIcon from "@material-ui/icons/TableChart";
import PublishIcon from "@material-ui/icons/Publish";
import ConvertIcon from "@material-ui/icons/SwapHoriz";
import PaletteIcon from "@material-ui/icons/Palette";
import CheckIcon from "@material-ui/icons/Check";
import BuildIcon from "@material-ui/icons/Build";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import ExtractPage from "src/components/loader/pages/ExtractPage";
import UploadPage from "src/components/loader/pages/UploadPage";
import ConvertXmlXerPage from "src/components/loader/pages/ConvertXmlXerPage";
import CleanupXerPage from "src/components/loader/pages/CleanupXerPage";
import LayoutPage from "src/components/loader/pages/LayoutPage";
import WelcomePage from "src/components/loader/pages/WelcomePage";
import ConfigurationProfileButton from "eai-configurator-ui/components/configuration/buttons/ConfigurationProfileButton";
import TeamsConfigurationPermission from "eai-configurator-ui/components/configuration/permission/TeamsConfigurationPermission";
import {useConfigProfile} from "eai-configurator-ui/components/configuration/profile/ConfigurationProfile";
import * as Utils from "eai-configurator-ui/components/Utils";
import XmlExtractPage from "src/components/loader/pages/XmlExtractPage";
import AutomateDatabasesPage from "src/components/loader/pages/AutomateDatabasesPage";
import AutomateJobsPage from "src/components/loader/pages/AutomateJobsPage";
import AutomateOptionsPage from "src/components/loader/pages/AutomateOptionsPage";
import ModuleOptionsPage from "src/components/loader/pages/ModuleOptionsPage";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";

const lightColor = "rgba(255, 255, 255, 0.7)";
const useStyles = makeStyles((theme) => ({
  button: {
    borderColor: lightColor,
  },
}));

function LoaderApplication() {
  const classes = useStyles();
  const [manageUsersDialogOpen, setManageUsersDialogOpen] = React.useState(false);
  const [mayShowManageOfflineLicenseDialog, setMayShowManageOfflineLicenseDialog] = React.useState(false);
  const [manageOfflineLicenseDialogOpen, setManageOfflineLicenseDialogOpen] = React.useState(false);
  const [navigationIndex, setNavigationIndex] = React.useState(0);
  const [subNavigationIndex, setSubNavigationIndex] = React.useState(null);
  // This is a prototype for enabled features
  const [enabledFeatures, setEnabledFeatures] = React.useState({
      layoutToolEnabled: false, automationEnabled: false,
      sessionProps: {
        licensed: false,
        wasApplicationLicensedAtLogin: false,
        applicationLicensed: false,
        showFullUserInterface: false,
        mayShowManageOfflineLicenseDialog: false,
        showManageOfflineLicenseDialog: false,
        showManageUsersDialog: false,
        restrictInterfaceLicenseNotValid: false,
        encryptLoaderFiles: false,
        encryptConfigurationFiles: false,
        encryptLocalDatabases: false,
        persistentTasks: true,
        persistentAutomatedDatabaseJobs: true,
      }
    }
  );
  React.useEffect(() => {
    setMayShowManageOfflineLicenseDialog(enabledFeatures.sessionProps.mayShowManageOfflineLicenseDialog)
  }, [enabledFeatures])

  const [navigationComponents, setNavigationComponents] = React.useState(() => [])
  const handleNavigationChange = (index, subIndex) => {
    setNavigationIndex(index);
    setSubNavigationIndex(subIndex);
  };
  const navigateToResults = () => {
    setNavigationIndex(0);
  };

  let history = useHistory();
  //-----------------------------------
  // Reads the enabled features, and builds the navigation components based on the features that are enabled
  //-----------------------------------
  React.useEffect(() => {
    retrieveSettingsUpdateData()
  }, [history.location]);

  React.useEffect(() => {
    updateNavigationComponentArray(enabledFeatures, enabledFeatures.sessionProps)
  }, [enabledFeatures])

  const retrieveSettingsUpdateData = () => {
    console.log("retrieveSettingsUpdateData");
    Utils.fetchData(
      "loader/enabledFeaturesPlusSessionInfo",
      {
        method: "GET"
      },
      false
    )
      .then((data) => {
        setEnabledFeatures(data);
      })
      .catch((response) => {
        Utils.getErrorMessage(response, "Request failed.").then((message) => {
          console.log("Error retrieving enabled features: " + message)
        });
      })
  }

  const updateNavigationComponentArray = (enabledFeaturesParam) => {
    const sessionProps = enabledFeaturesParam.sessionProps;
    const baseArray = Array(0);

    console.log("updateNavigationComponentArray")
    console.table(sessionProps);

    if (sessionProps.showFullUserInterface) {
      baseArray.push(
        {
          key: "Tasks",
          section: "Results",
          label: "Tasks",
          icon: <AssignmentTurnedInIcon/>,
          component: <LoaderTasksPage enabledFeatures={enabledFeaturesParam}/>,
        },
        {
          key: "Extract",
          section: "Operations",
          label: "Extract",
          icon: <GetAppIcon/>,
          component: (
            <ExtractPage navigateToResults={navigateToResults}/>
          ),
        },
        {
          key: "Upload",
          section: "Operations",
          label: "Upload",
          icon: <PublishIcon/>,
          component: (
            <UploadPage navigateToResults={navigateToResults}/>
          ),
        },
        {
          key: "Extract XML",
          section: "Operations",
          label: "Extract XML",
          icon: <GetAppIcon/>,
          component: (
            <XmlExtractPage navigateToResults={navigateToResults}/>
          ),
        },
        {
          key: "Convert XML & XER",
          section: "Operations",
          label: "Convert XML & XER",
          icon: <ConvertIcon/>,
          component: (
            <ConvertXmlXerPage navigateToResults={navigateToResults}/>
          ),
        },
        {
          key: "Cleanup XER",
          section: "Operations",
          label: "Cleanup XER",
          icon: <CheckIcon/>,
          component: (
            <CleanupXerPage navigateToResults={navigateToResults}/>
          ),
        }
      )
    }


    //
    // Only adds the layout tool option if it is enabled in the features
    //
    console.log("Layout tool enabled: " + enabledFeaturesParam.layoutToolEnabled);
    if (sessionProps.showFullUserInterface && enabledFeaturesParam.layoutToolEnabled) {
      baseArray.push({
        key: "Layouts",
        section: "Operations",
        label: "Layouts",
        icon: <PaletteIcon/>,
        component: (
          <LayoutPage navigateToResults={navigateToResults}/>
        ),
      })
    }

    //
    // Options now
    baseArray.push({
      key: "Modules",
      section: "Options",
      label: "Modules",
      icon: <AssignmentTurnedInIcon/>,
      component: (
        <ModuleOptionsPage navigateToResults={navigateToResults}/>
      )
    });
    /*
        baseArray.push({
          key: "Resource Assignments",
          section: "Options",
          label: "Resource Assignments",
          icon: <AssignmentTurnedInIcon/>,
          component: (
            <ModuleOptionsPage navigateToResults={navigateToResults}/>
          )
        });
    */

    if (sessionProps.showFullUserInterface && enabledFeaturesParam.automationEnabled) {
      baseArray.push({
          key: "Databases",
          section: "Automate",
          label: "Databases",
          icon: <TableChartIcon/>,
          component: (
            <AutomateDatabasesPage navigateToResults={navigateToResults}/>
          ),
        },
      )
      if (sessionProps.showFullUserInterface) {
        baseArray.push({
            key: "Jobs",
            section: "Automate",
            label: "Jobs",
            icon: <BuildIcon/>,
            component: (
              <AutomateJobsPage
                encryptLoaderFiles={enabledFeatures.sessionProps.encryptLoaderFiles}
                navigateToResults={navigateToResults}/>
            ),
          },
        )
        baseArray.push({
            key: "Automate Modules",
            section: "Automate",
            label: "Automate Modules",
            icon: <AssignmentTurnedInIcon/>,
            component: (
              <AutomateOptionsPage navigateToResults={navigateToResults}/>
            ),
          },
        )
      }
    }

    console.table(baseArray)
    setNavigationComponents(baseArray);
  }

  const [configProfile] = useConfigProfile();

  return (
    <Application
      login={<Login useDatabase appName={"P6 Loader"} afterLogin={retrieveSettingsUpdateData}/>}
      application={{
        routes: [
          {
            path: "/loader",
            component: (
              <ConfigurationDashboard
                navigationIndex={navigationIndex}
                subNavigationIndex={subNavigationIndex}
                handleNavigationChange={handleNavigationChange}
                navigationPanelWidth={250}
                buttonAreaWidth={300}
                navigation={navigationComponents}
                welcomeContent={{
                  label: "P6 Loader",
                  component: <WelcomePage/>,
                }}
                headerButtons={[
                  <ConfigurationProfileButton profile={configProfile} key="configurationProfilesButton"/>,
                  <MessagesButton key="messagesButton"/>,
                  <HelpButton key="helpButton"/>,
                  mayShowManageOfflineLicenseDialog && (<Button
                    key="mangeOfflineLicenseButton"
                    className={classes.button}
                    variant="outlined"
                    color="inherit"
                    size="small"
                    onClick={() => setManageOfflineLicenseDialogOpen(true)}
                  >
                    Manage License
                  </Button>),
                  <AccountButton
                    key="manageUsersButton"
                    buttons={[
                      enabledFeatures.sessionProps.showFullUserInterface && enabledFeatures.sessionProps.mayShowManageUsersDialog && (<ManageUsersButton
                        handleClick={() => setManageUsersDialogOpen(true)}
                      />),
                    ]}
                  />,
                ]}
                actionButtons={[
                  enabledFeatures.sessionProps.showFullUserInterface && (<SaveConfigurationButton
                    key="manageDefinitionsButton"
                    label="Save & Load Definitions"
                    profileLabel={"Loader Definition"}
                    PermissionConfigurationComponent={
                      TeamsConfigurationPermission
                    }
                  />),
                ]}
              />
            ),
          },
        ],
        defaultRoute: "loader",
      }}
    >
      <ManageLoaderUsersDialog
        open={manageUsersDialogOpen}
        handleClose={() => setManageUsersDialogOpen(false)}
        layoutToolEnabled={enabledFeatures.layoutToolEnabled}
        automationEnabled={enabledFeatures.automationEnabled}
      />
      {mayShowManageOfflineLicenseDialog && (
        <ManageOfflineLicenseDialog
          open={manageOfflineLicenseDialogOpen}
          handleClose={() => setManageOfflineLicenseDialogOpen(false)}
        />
      )
      }
    </Application>
  );
}

export default LoaderApplication;
